/**
 * Battery System Requirements Notification
 * Extracted from EnginePropulsionSection to maintain file size limits
 */
import React from 'react';

const BatterySystemRequirements = ({ currentPropulsionType }) => {
  // Only show for battery systems
  if (!['battery_electric', 'battery_hybrid'].includes(currentPropulsionType)) {
    return null;
  }

  return (
    <div className="sm:col-span-6">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-amber-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-amber-800">
              {currentPropulsionType === 'battery_electric' ? 'Battery Electric' : 'Battery Hybrid'} System Requirements
            </h3>
            <div className="mt-2 text-sm text-amber-700">
              <p>⚡ <strong>WBC3 {currentPropulsionType === 'battery_electric' ? 'Section 8.4' : 'Section 8.5'} + Annex 1 Requirements:</strong></p>
              <ul className="list-disc ml-5 mt-1 space-y-1">
                <li>Fixed fire suppression system (mandatory)</li>
                <li>Smoke, heat & flame detection</li>
                <li>Minimum 6 air changes per hour ventilation</li>
                {currentPropulsionType === 'battery_electric' && (
                  <li>Lithium-ion batteries may require gas detection</li>
                )}
                {currentPropulsionType === 'battery_hybrid' && (
                  <li>Protection required for both diesel engine AND battery components</li>
                )}
              </ul>
              <p className="mt-2 font-medium">
                📋 Complete battery system configuration will be available in the next update.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BatterySystemRequirements;